import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../types/store'
import { alertErrorMessage } from '../../../utils/Errors'
import { NotificationStatus } from '../../../types/notifications'
import { getUrlWithVersion } from '../../../api/api'

export const markNotification = createAsyncThunk<
    { notificationId: string; status: NotificationStatus },
    { notificationId: string; status: NotificationStatus },
    ThunkConfig<string>
>('notificationsSlice/markNotification', async (args, thunkAPI) => {
    const {
        extra: { api },
        rejectWithValue,
    } = thunkAPI

    const { notificationId, status } = args

    try {
        await api.put(
            getUrlWithVersion(`/notifications/${notificationId}/status`),
            { status }
        )

        return { notificationId, status }
    } catch (e) {
        alertErrorMessage(e)
        return rejectWithValue('Failed to mark notification')
    }
})
